export default class TabIndexUtil {
	public static getFocusableElements(parent: HTMLElement): HTMLElement[] {
		return Array.from(
			parent.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
		);
	}

	public static lockTabulator(parent: HTMLElement): void {
		TabIndexUtil.getFocusableElements(parent).forEach((element): void => {
			element.setAttribute('tabindex', '-1');
		});
	}

	public static unlockTabulator(parent: HTMLElement): void {
		TabIndexUtil.getFocusableElements(parent).forEach((element): void => {
			element.removeAttribute('tabindex');
		});
	}
}
